import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslateModule} from '@ngx-translate/core';
import {Q9HtmlEncoderPipe} from '@q9elements/ui-kit/common';
import {TagComponent, UserInfoComponent} from '@q9elements/ui-kit/components';
import {VersionsService} from '../../../../../core/services/versions.service';
import {VersionStatePipe} from '../../version-state.pipe';

@Component({
  selector: 'app-version-history-tree',
  templateUrl: './version-history-tree.component.html',
  styleUrls: ['./version-history-tree.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatTooltipModule,
    MatIconModule,
    TranslateModule,
    VersionStatePipe,
    Q9HtmlEncoderPipe,
    TagComponent,
    UserInfoComponent
  ]
})
export class VersionHistoryTreeComponent {
  constructor(protected versionsSvc: VersionsService) {}

  @Input() versionHistoryItem;
}
